import {
  Node,
  nodeInputRule,
  mergeAttributes,
} from '@tiptap/core'

export const inputRegex = /!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\)/

export default Node.create({
  name: 'audio',

  addOptions: {
    inline: false,
    HTMLAttributes: {},
  },

  inline() {
    return this.options.inline
  },

  group() {
    return this.options.inline ? 'inline' : 'block'
  },

  draggable: true,

  addAttributes() {
    return {
      id: {
        default: '',
        renderHTML: attributes => {
          return {
            mediaobjectid: attributes.id,
          }
        },
        parseHTML: element => element.id,
      },
      src: {
        default: null,
        parseHTML: element => element.childNodes[0] ? element.childNodes[0].src : element.src,
      },
      type: {
        default: null,
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'audio',
      },
    ]
  },

  renderHTML({ HTMLAttributes, node: { attrs } }) {
    return ['audio', { controls: true, id: attrs.id }, ['source', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)]]
  },

  addCommands() {
    return {
      setAudio: options => ({ commands }) => {
        return commands.insertContent({
          type: this.name,
          attrs: options,
        })
      },
      setAudioSrc: src => ({ commands }) => {
        commands.updateAttributes(this.name, { src: src })
      },
      setAudioMediaObjectId: id => ({ commands }) => {
        commands.updateAttributes(this.name, { id: id })
      },
      clearAudioMediaObject: () => ({ commands }) => {
        commands.updateAttributes(this.name, { src: null, id: null })
      },
    }
  },

  addInputRules() {
    return [
      nodeInputRule({
        find: inputRegex,
        type: this.type,
        getAttributes: (match) => {
          const [, alt, src, title] = match

          return { src, alt, title }
        },
      }),
    ]
  },
})
